import {
  DList,
  DListResponse,
  DObjectResponse,
  TriggerTypes,
} from 'models/common.model';

export type BoothModel = {
  id: number;
  code: string;
  name: string;
  type: number;
  storeId: number;
  subscriberId: number;
  layoutListId: number;
  themeListId: number;
  reason: string;
  isActive: boolean;
  orderNo: number;
  storeName: string;
  subscriberName: string;
  layoutListName: string;
  themeListName: string;
  stickerListId: string;
  stickerListName: string;
  backgroundListId: string;
  backgroundListName: string;
  capturePositionListId: string;
  capturePositionListName: string;
  uiTemplateId: number;
  uiTemplateName: string;
  webAppVersion: string;
  syncVersion: string;
  filterListId: string;
  filterListName: string;
  albumId: string;
  albumName: string;
  mediaAdsListId: string;
  mediaAdsListName: string;
  currencyId: string;
  currencyName: string;
  languageId: string;
  languageName: string;
  fromTime: string;
  toTime: string;
  numberOfUses: number;
  chatBots: ChatBots[];
};

export type GetBoothRequestModel = {
  id?: number;
};
export type GetBoothResponseModel = DObjectResponse<BoothModel>;

export type GetBoothIdentityRequestModel = {
  id?: number;
};
export type GetBoothIdentityResponseModel = DObjectResponse<{
  data: {
    id: number;
    boothHash: string;
  };
}>;

export type ListBoothRequestModel = {
  pageIndex?: number;
  pageSize?: number;
  name?: string;
  storeId?: number | null;
  layoutListId?: number | null;
  themeListId?: number | null;
  isActive?: boolean | null;
};
export type ListBoothResponseModel = DListResponse<BoothModel>;

export type SaveBoothRequestModel = {
  id?: number;
  code: string;
  name: string;
  storeId: number;
  orderNo: number;
  layoutListId: number;
  themeListId: number;
  subscriberId: number;
  mediaAdsListId: number | null;
  albumId: number | null;
  languageId: number | null;
  currencyId: number | null;
};
export type SaveBoothResponseModel = DObjectResponse<boolean>;

export type UpdateBoothVersionRequestModel = {
  storeId?: number | null;
  layoutListId?: string;
  themeListId?: string;
  themeVideoListId?: number;
  backgroundListId?: number;
  capturePositionListId?: number;
  name?: string;
  isActive?: boolean | null;
  listBoothId: number[];
  isAll?: boolean;
  syncVersion: string;
  webAppVersion: string;
};
export type UpdateBoothVersionResponseModel = DObjectResponse<boolean>;

export type DeleteBoothRequestModel = {
  id?: number;
};
export type DeleteBoothResponseModel = DObjectResponse<boolean>;

export type InactiveBoothRequestModel = {
  id?: number;
  reason: string;
};
export type InactiveBoothResponseModel = DObjectResponse<boolean>;

export type ActiveBoothRequestModel = {
  id?: number;
  reason: string;
};
export type ActiveBoothResponseModel = DObjectResponse<boolean>;

export interface BoothStateModel {
  boothListData: DList<BoothModel> | null;
  boothDetail: BoothModel | null;
  boothIdentityId: string;
  triggerSaveBooth: TriggerTypes | null;

  loadingList: boolean;
  loadingDetail: boolean;
  loadingUpdateBoothVersion: boolean;
}

export enum ChatBotBoothType {
  FUN_ADMIN = 1,
  TELEGRAM = 2,
  DISCORD = 3,
}

export type ChatBots = {
  id: number;
  boothId: number;
  chatBotType: string;
  chatBotId: string;
  chatBotMomoId: string;
};
